import { render, staticRenderFns } from "./AppRealTimeReport.vue?vue&type=template&id=0fb27670&scoped=true&"
import script from "./AppRealTimeReport.vue?vue&type=script&lang=js&"
export * from "./AppRealTimeReport.vue?vue&type=script&lang=js&"
import style0 from "./AppRealTimeReport.vue?vue&type=style&index=0&id=0fb27670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb27670",
  null
  
)

export default component.exports